import TIM from 'tim-js-sdk/tim-js.js'
import { getImUsersig } from '@/api/modules/timeUtils'

const tim = TIM.create({
  SDKAppID: 1400746436
})

export const timLogin = async function() {
  const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
  const userId = user.id
  const userSig = await getUsersig(userId)
  console.log(userSig)
  tim.login({ userID: userId, userSig: userSig })
  tim.on(TIM.EVENT.SDK_READY, event => {
    // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
    // event.name - TIM.EVENT.SDK_READY
    console.log('SDK_READY:::', event)
  })
  tim.on(TIM.EVENT.MESSAGE_RECEIVED, event => {
    // 收到推送的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // event.name - TIM.EVENT.MESSAGE_RECEIVED
    // event.data - 存储 Message 对象的数组 - [Message]
    console.log('MESSAGE_RECEIVED:::', event)
  })
}
export const getUsersig = async function(userId) {
  const res = await getImUsersig(userId)
  if (res.code === 0) {
    return res.data
  }
  else {
    return ''
  }
}
